var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.00002V12L9.5 13.5M12.51 17.35L12.16 21.18C12.1149 21.6787 11.8845 22.1423 11.5142 22.4792C11.1439 22.8162 10.6607 23.002 10.16 23H5.83C5.32933 23.002 4.84611 22.8162 4.4758 22.4792C4.1055 22.1423 3.87506 21.6787 3.83 21.18L3.48 17.35M3.49 6.65002L3.84 2.82002C3.88491 2.32309 4.11393 1.8609 4.48211 1.52417C4.8503 1.18744 5.33105 1.00049 5.83 1.00002H10.18C10.6807 0.997985 11.1639 1.18381 11.5342 1.52079C11.9045 1.85776 12.1349 2.32137 12.18 2.82002L12.53 6.65002M15 12C15 15.866 11.866 19 8 19C4.13401 19 1 15.866 1 12C1 8.13402 4.13401 5.00002 8 5.00002C11.866 5.00002 15 8.13402 15 12Z",
    stroke: "#8DC63F",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/Watch.a9b470544acc37b6e41b894c9b7bf77e.svg";
export { ForwardRef as ReactComponent };